import Emitter from '@/plugins/emitter';

export default class Form extends Emitter {
  $children = new Map();

  $rules = [];

  $parent = null;

  $el = null;

  show = true;

  disabled = false;

  init() {
  }

  get(key) {
    this.$children.get(key);
  }

  set(key, item) {
    this[key] = item;
    this.$children.set(key, item);
  }

  toValidate() {
    const all = [];
    this.$children.forEach((item) => {
      if (!item || !item.el || item.disabled || !item.show || !item.toValidate) {
        return;
      }
      all.push(item.toValidate());
    });
    return Promise.all(all);
  }

  toReset() {
    const all = [];
    this.$children.forEach((item) => {
      if (!item || !item.toReset) {
        return;
      }
      all.push(item.toReset());
    });
    return Promise.all(all);
  }

  toSubmit() {
    const all = [];
    this.$children.forEach((item) => {
      if (!item) {
        return;
      }
      if (item.submit) {
        all.push(item.submit());
      } else if (item.toSubmit) {
        all.push(item.toSubmit());
      }
    });
    return Promise.all(all);
  }

  toData() {
    const data = {};
    this.$children.forEach((item) => {
      if (!item) {
        return;
      }
      Object.assign(data, item.toData());
    });
    return data;
  }

  async submit() {
    await this.toValidate();
    await this.toSubmit();
    return this.toData();
  }
}
